export const AmountNatureType = {
  PercentageOfBasePrice: {
    key: 1,
    value: 'Percentage Of Base Price',
  },
  PercentageOfSellingPrice: {
    key: 2,
    value: 'Percentage Of Selling Price',
  },
  PercentageOfRemainingBalance: {
    key: 3,
    value: 'Percentage Of Remaining Balance',
  },
  FixedAmount: {
    key: 4,
    value: 'Fixed Amount',
  },
};
